import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button"; // Import Button component
import { toast } from "react-toastify";
import { axiosApi } from "../../../constants/axios_api";
import appUrl from "../../../constants/appUrl";
import CreateGift from "./CreateGift"; // Import the CreateGift component
import { useSelector } from "react-redux";

const GiftDataPage = () => {
    const getUsersListReducer = useSelector((state) => state.usersList);
    const [giftData, setGiftData] = useState([]);
    const [displayDialog, setDisplayDialog] = useState(false); // State to control dialog visibility
    const [selectedGift, setSelectedGift] = useState(null); // State to store selected gift for editing
    const { loading } = getUsersListReducer;

    const getGiftData = async () => {
        try {
            const response = await axiosApi.get(`${appUrl.baseUrl}api/prizeRouter/gift`);
            setGiftData(response?.data?.data || []);
        } catch (error) {
            console.error("Error fetching gift data:", error.response ? error.response.data : error.message);
            toast.error(error.response ? error.response.data.message : error.message);
        }
    };

    useEffect(() => {
        getGiftData();
    }, []);

    const editGift = (gift) => {
        setSelectedGift(gift);
        setDisplayDialog(true);
    };

    const actionBodyTemplate = (rowData) => {
        return <Button icon="pi pi-pencil" className="p-button-rounded p-button-success" onClick={() => editGift(rowData)} />;
    };

    return (
        <div className="custom-dialog">
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", marginBottom: "10px" }}>
                <h3 style={{ margin: "0" }}>Gift Data</h3>
                <button
                    className="p-button p-component m-0"
                    onClick={() => {
                        setSelectedGift(null);
                        setDisplayDialog(true);
                    }}
                >
                    Add Gift
                </button>
            </div>
            <DataTable loading={loading} responsiveLayout="scroll" value={giftData} paginator rows={10} className="p-datatable-customers" emptyMessage="No record found." style={{ width: "100%" }}>
                <Column field="giftName" header="Gift Name" />
                <Column field="quantity" header="Quantity" />
                <Column field="color" header="Color" />
                <Column field="price" header="Price" />
                <Column field="description" header="Description" />
                <Column body={actionBodyTemplate} header="Actions" />
            </DataTable>
            <Dialog header={selectedGift ? "Edit Gift" : "Create Gift"} visible={displayDialog} style={{ width: "50vw" }} onHide={() => setDisplayDialog(false)}>
                <CreateGift
                    gift={selectedGift}
                    onClose={() => {
                        setDisplayDialog(false);
                        getGiftData();
                    }}
                />
            </Dialog>
        </div>
    );
};

export default GiftDataPage;
